export enum EDayOfWeek {
  Sunday = 0,

  Monday = 1,

  Tuesday = 2,

  Wednesday = 3,

  Thursday = 4,

  Friday = 5,

  Saturday = 6,
}

export const DayOfWeekLabels: Record<EDayOfWeek, string> = {
  [EDayOfWeek.Sunday]: "sunday",

  [EDayOfWeek.Monday]: "monday",

  [EDayOfWeek.Tuesday]: "tuesday",

  [EDayOfWeek.Wednesday]: "wednesday",

  [EDayOfWeek.Thursday]: "thursday",

  [EDayOfWeek.Friday]: "friday",

  [EDayOfWeek.Saturday]: "saturday",
}
